import { Col, Container, Row, } from 'react-bootstrap';
import "./Referal_steps.css";

const Referal_steps = () => {
    const steps = [
        {
            id: "01",
            title: "Share Your Referral Link",
            desc: "Copy or send your unique link to friends.",
            img: "/assets/images/home/refer_and_earn/referal_steps/broken-link.png",
        },
        {
            id: "02",
            title: "Friend Joins and Signs Up",
            desc: "They download the app & complete registration.",
            img: "/assets/images/home/refer_and_earn/referal_steps/people.png",
        },
        {
            id: "03",
            title: "First Transaction Success",
            desc: "Your friend recharges or makes a payment.",
            img: "/assets/images/home/refer_and_earn/referal_steps/banking.png",
        },
        {
            id: "04",
            title: "You Both Earn Rewards",
            desc: "Get instant cashback, bonus, or wallet credits.",
            img: "/assets/images/home/refer_and_earn/referal_steps/gift.png",
        },
    ];

    return (
        <div className='referal-section'>
            <Container>
                <Row className='justify-content-center'>
                    {steps.map((step) => (
                        <Col key={step.id} xl={3} md={3} sm={6} xs={6}>

                            <div className='referal-card'>
                                <div className='icon-box'>
                                    <img src={step.img} alt={step.title} className='images' />
                                </div>
                                <h5 className='step-number'>{step.id}</h5>
                                <h6 className='step-title'>{step.title}</h6>
                                <hr id='hr' />
                                <p className='step-desc'>{step.desc}</p>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
};

export default Referal_steps;

